import { Contact } from "../../Project";
import React from "react";
import { Media, Texts, Title, Button } from "../../Object";
import { Grid, Space } from "../../Layout";
import Nav from "./Nav";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <FixContact />
      <Link className="p-img__fix-contact__link pc" to="/contact/">
        <Media src={`common/icon-fix-contact`} alt={'まずは無料で相談'} class={`p-img__fix-contact`} />
      </Link>
      <Contact />
      <footer className="l-footer">
        <div className="l-row" data-state="left">
          <div className="l-footer__wrap--main">
            <div className="l-footer__inner--left">
              <Banner />
            </div>

            <div className="l-footer__inner--right">
              <Nav remove={['fix']} position="footer" />
              <Space size={['56px', '48px']} />
              <div className="l-footer__inner--bottom">
                <Media
                  src="common/icon-logo"
                  class="l-header__img--logo"
                  alt="tequst"
                ></Media>
                <Texts class="c-text--gray-2" slug="footer/address"></Texts>
              </div>
              <Space size={['24px 0 0', '18px 0 0']}>
                <Texts class="c-text--gray-2" slug="footer/copy"></Texts>
              </Space>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const FixContact = () => {
  return (
    <div className="l-footer__wrap--fix">
      <Link to="tel:0669648103">
        <Media
          src="common/fix-call"
          class="l-footer__wrap--fix__media"
          alt="number"
        ></Media>
      </Link>
      <Link target="__blank" to="https://lin.ee/LTaN2bT">
        <Media
          src="common/fix-line"
          class="l-footer__wrap--fix__media"
          alt="line"
          state="line"
        ></Media>
      </Link>
      <Link to="/contact">
        <Media
          state="mail"
          src="common/fix-mail"
          class="l-footer__wrap--fix__media"
          alt="お問い合わせフォーム"
        ></Media>
      </Link>
    </div>
  );
};

const Banner = () => {
  return (
    <>
      <div className="p-box__banner__wrap">

        <Link to="https://www.instagram.com/hp__webidea/?hl=ja" target="__blank">
          <div className="p-box__banner" data-state="insta">
            <div className="p-box__banner--inner">
              <Texts
                slug={`title/insta`}
                class={"c-text--en c-text--big c-text--white"}
              />
              <Space size={["32px 0 24px", "24px 0"]}>
                <div className="p-box__banner--insta">
                  <Media src={`common/icon-insta`} alt={'instagram'} class={`p-img__insta`} />
                  <Texts slug={`footer-banner/insta-title`} class={"c-text--white"} />
                </div>
              </Space>
              <Texts
                slug={`footer-banner/insta-body`}
                class={"c-text--white c-text--bold"}
              />
            </div>
            <Media src={`common/icon-arrow-gray`} alt={'arrow'} class={`p-img__gray-arrow`} />
          </div>
        </Link>

        <Link to="/recruit/">
          <div className="p-box__banner" data-state="form">
            <div className="p-box__banner--inner">
              <Texts slug={`footer-banner/form-title`} class={"c-text--white"} />
              <Space size={['24px 0 0', '24px 0 0']}>
                <Texts
                  slug={`footer-banner/form-body`}
                  class={"c-text--white c-text--bold"}
                />
              </Space>
            </div>
            <Media src={`common/icon-arrow-gray`} alt={'arrow'} class={`p-img__gray-arrow`} />
          </div>
        </Link>

      </div>
    </>
  );
};

export default Footer;
